import {
	Box,
	TextField,
	FormControl,
	InputAdornment,
	InputLabel,
	Input,
	IconButton,
	Button,
	Typography,
	Select,
	MenuItem,
	FormHelperText,
	Alert,
	Chip,
	Popover,
} from "@mui/material";
import {
	AccountCircleOutlined,
	Visibility,
	VisibilityOff,
	LockOutlined,
	Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set } from "lodash";
import { Tabs } from "../../components/tabs";
import { Grid } from "../../components/table";
import { CONFIG } from "../../../config";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA } from "../../components/form";
import moment from "moment";
import { getFormState } from "../../../helpers/form";
import dayjs from "dayjs";
import IosShareIcon from "@mui/icons-material/IosShare";
const durationPulgin = require("dayjs/plugin/duration");
dayjs.extend(durationPulgin);
const API_HOST = CONFIG.modules["accounts"].host;

export const LeaveReports = (props) => {
	const {
		roles,
		user,
		users,
		Designations,
		Departments,
		Languages,
		Districts,
	} = useSelector((state) => state.user || {});

	const [active, setActive] = useState("Tele-Caller");
	const [data, setData] = useState(users || []);
	const [filter, setFilter] = useState({
        from: dayjs('01-01-2023'),
        to: dayjs(),
    })
	const [anchorEl, setAnchorEl] = useState(null);
	const openP = Boolean(anchorEl);
	const [rangeData, setRangeData] = useState({});
	const [selected, setSelected] = useState(null);

	const exportLeavesByUser = (id, name) => {
        axios.get(API_HOST + `/export-leaves-by-agent?user=${id}&from=${encodeURIComponent(dayjs(filter.from).format('YYYY-MM-DD'))}&to=${encodeURIComponent(dayjs(filter.to).format('YYYY-MM-DD'))}`, {
            responseType: 'arraybuffer'
        }).then((resp) => {
            if (resp) {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download',`Leave_Report_${name || id}.xlsx`);
				document.body.appendChild(link);
				link.click();
				console.log(resp)
				link.remove()
				}
        }).catch((e) => {
            console.log(e)
        })
    }


	const fetchLeaveReport = () => {
		setData([]);
		axios
			.get(
				API_HOST +
					`/leave-report?${
						filter.from?`&from=${dayjs(filter.from).format('YYYY-MM-DD')}`:''
						}${filter.to?`&to=${dayjs(filter.to).format('YYYY-MM-DD')}`:''}`
			)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setData(resp.data.data);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		fetchLeaveReport();
	}, [filter]);

	useEffect(() => {
		fetchLeaveReport();
	}, [active]);

	return (
		<>
			{/* <Tabs items={items} active={active} onChange={(key) => {
              setActive(key)
          }} /> */}
			<ToolBar
				name={active}
				// buttons={[
				// 	{
				// 		name: "Export",
				// 		// type: 'chip',
				// 		icon: () => <IosShareIcon sx={{ fontSize: "1.2em" }} />,
				// 		onClick: () => {
				// 			exportData();
				// 		},
				// 	},
				// ]}
				filters={[
              
                    {
                        field: {
                            name: 'from',
                            type: 'date',
                            label: 'From',
                        },
                        onChange: (name, value) => {
                            filter[name] = value
                            setFilter({...filter})
                        },
                        state: filter

                    },
                    {
                        field: {
                            name: 'to',
                            type: 'date',
                            label: 'To',
                        },
                        onChange: (name, value) => {
                            filter[name] = value
                            setFilter({...filter})
                        },
                        state: filter

                    }
                ]}
			/>
			<Box sx={{ mt: 2 }}>
				<Grid
					data={data}
					columns={[
						{ id: "name", label: "Name", minWidth: 170 },
						{
							id: "uuid",
							label: "Emp. Code",
							minWidth: 170,
						},
						{
							id: "no",
							label: "No. of Leaves",
							minWidth: 170,
						},
						{
							id: "types",
							label: "Type of Leaves",
							minWidth: 170,
						},

						{
							id: "_id",
							label: "Action",
							minWidth: 70,
							format: (data, row) => {
								return (
									<Button
										onClick={(e) => {
											exportLeavesByUser(data, row.name)
										}}
									>
										Report
									</Button>
								);
							},
						},
					]}
				></Grid>
			</Box>
		</>
	);
};
